import { gql } from '@apollo/client';

export interface UploadPodCaptureExampleImageInput {
    fileBase64: string;
    filename: string;
    contentType: string;
}

export interface PodCaptureExampleImageUploadType {
    objectKey: string;
    publicUrl: string;
}

export interface UploadPodCaptureExampleImageResponse {
    uploadPodCaptureExampleImage: PodCaptureExampleImageUploadType;
}

export const UPLOAD_POD_CAPTURE_EXAMPLE_IMAGE = gql`
    mutation UploadPodCaptureExampleImage($input: UploadPodCaptureExampleImageInput!) {
        uploadPodCaptureExampleImage(input: $input) {
            objectKey
            publicUrl
        }
    }
`;
